"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonOnboardingErrors = void 0;
const result_1 = require("@leavy/result");
var CommonOnboardingErrors;
(function (CommonOnboardingErrors) {
    /**
     * This error occurs when trying to modify an onboarding that does not exist.
     */
    CommonOnboardingErrors.OnboardingNotFound = (0, result_1.Bad)("ONBOARDING_NOT_FOUND");
    /**
     * This error occurs when trying to modify an onboarding that is no longer open for modification.
     * It typically occurs when the onboarding has already been submitted by the user, and/or has been accepted or rejected by Leavy.
     */
    CommonOnboardingErrors.OnboardingWrongState = (0, result_1.Bad)("ONBOARDING_WRONG_STATE");
    /**
     * This error occurs when trying to submit a step for which not all of the required information has been provided.
     */
    CommonOnboardingErrors.StepIncomplete = (0, result_1.Bad)("STEP_INCOMPLETE");
})(CommonOnboardingErrors = exports.CommonOnboardingErrors || (exports.CommonOnboardingErrors = {}));
//# sourceMappingURL=CommonOnboardingErrors.js.map